import { render, staticRenderFns } from "./SuperSheet.vue?vue&type=template&id=2f27bdda&scoped=true&"
import script from "./SuperSheet.vue?vue&type=script&lang=ts&"
export * from "./SuperSheet.vue?vue&type=script&lang=ts&"
import style0 from "./SuperSheet.vue?vue&type=style&index=0&id=2f27bdda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f27bdda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
